import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getAudit, unwrapGet } from "../../../helpers/auditHub_helper";
import { scorePercent } from "../AuditHub/utils";

const scoreLabel = (value) => {
  const percent = scorePercent(value);
  if (percent == null) return "Not yet scored";
  return `${Math.round(percent)}%`;
};

const AuditContextBar = ({ auditId }) => {
  const history = useHistory();
  const [state, setState] = useState({ status: "idle", audit: null, error: null });

  useEffect(() => {
    if (!auditId) {
      setState({ status: "idle", audit: null, error: null });
      return undefined;
    }
    let cancelled = false;
    setState({ status: "loading", audit: null, error: null });
    getAudit(auditId)
      .then((res) => {
        if (!cancelled) setState({ status: "ready", audit: unwrapGet(res), error: null });
      })
      .catch((error) => {
        if (!cancelled) {
          setState({
            status: "error",
            audit: null,
            error: error?.message || "Unable to load this audit.",
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [auditId]);

  if (!auditId) return null;

  return (
    <Box
      sx={{
        border: "1px solid #e5e7eb",
        borderRadius: "10px",
        backgroundColor: "#fff",
        px: 2,
        py: 1.25,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      {state.status === "loading" ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CircularProgress size={16} />
          <Typography sx={{ fontSize: 13, color: "#64748b" }}>Loading audit…</Typography>
        </Box>
      ) : state.status === "error" ? (
        <Typography sx={{ fontSize: 13, color: "#b91c1c" }}>{state.error}</Typography>
      ) : (
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#64748b" }}>
            {state.audit?.auditCode || auditId}
          </Typography>
          <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>
            {state.audit?.name || "Audit"}
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#475569" }}>
            {state.audit?.ownerEmail ? `Owner ${state.audit.ownerEmail}` : "No owner"}
            {` · Score ${scoreLabel(state.audit?.auditScore)}`}
            {` · ${state.audit?.accountCount ?? 0} accounts`}
            {` · ${state.audit?.scopeCount ?? 0} frameworks`}
          </Typography>
        </Box>
      )}
      <Button onClick={() => history.push("/audit-hub")} sx={{ textTransform: "none", fontWeight: 600 }}>
        Back to Audit Hub
      </Button>
    </Box>
  );
};

export default AuditContextBar;
